import { render, staticRenderFns } from "./ScheduledChangesTab.vue?vue&type=template&id=0bbeb0fa"
import script from "./ScheduledChangesTab.vue?vue&type=script&lang=js"
export * from "./ScheduledChangesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports